export const CustomerRoles = {
  SELLER: 'SELLER',
  BUYER: 'BUYER',
  MODERATOR: 'MODERATOR',
  COHOST: 'COHOST',
}
